import React, { useContext, useEffect,  useMemo,  useState } from 'react'
import "./Hot.css"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import { StarOutline } from "@mui/icons-material"
import { useNavigate } from "react-router-dom";
import LoadingAnimation from "../../LoadingAnimation/LoadingAnimation"
import { StarttrackingContext } from '../../Context/StartTrackingContext/StarttrackingContext';

function Hot() {
  const [dataBtc, setDataBtc] = useState("")
  const [dataEth, setDataEth] = useState("")
  const [dataAda, setDataAda] = useState("")
  const [dataDot, setDataDot] = useState("")
  const [dataDoge, setDataDoge] = useState("")
  const [dataMatic, setDataMatic] = useState("")

  //dispatch
  const { dispatch } = useContext(StarttrackingContext)

  const [ loading, setLoading ] = useState(false)
  const [ error, setError ] = useState(false)
  const navigate = useNavigate()

  
  //fetch Bitcoin
  let timer;
  useEffect(()=>{
  setLoading(true)
  setDataBtc(JSON.parse(localStorage.getItem("bitcoin")))
  timer = setInterval(()=>{
        const URL = "https://api.coincap.io/v2/assets/bitcoin"
        const fetchData =async (URL)=>{
          try{
            const res = await axios.get(URL)
            localStorage.setItem("bitcoin" , JSON.stringify(res.data))
            setDataBtc(res.data)
            setLoading(false)
            setError(false)
            
          }catch(err){
            setDataBtc(JSON.parse(localStorage.getItem("bitcoin")))
            setLoading(false)
            setError(true)
          }
        }
        fetchData(URL)
        },200)
        return ()=>{clearInterval(timer)}
        
      },[URL])

      //cache
      // const memoizedIndividualDataBtc = useMemo(()=> dataBtc ,[dataBtc])

      //all data from API
      const apiDataBtc  = dataBtc

      //all data which aint filtered
      const datazzBtc =  [apiDataBtc?.data]


  //fetch  Etherium
  let timers;
  useEffect(()=>{
  setLoading(true)
  setDataEth(JSON.parse(localStorage.getItem("ethereum")))
  timers = setInterval(()=>{
        const URL = "https://api.coincap.io/v2/assets/ethereum"
        const fetchData =async (URL)=>{
          try{
            const res = await axios.get(URL)
            localStorage.setItem("ethereum" , JSON.stringify(res.data))
            setDataEth(res.data)
            setLoading(false)
            setError(false)
            
          }catch(err){
            setDataEth(JSON.parse(localStorage.getItem("ethereum")))
            setLoading(false)
            setError(true)
          }
        }
        fetchData(URL)
        },200)
        return ()=>{clearInterval(timers)}
        
      },[URL])

      //cache
      // const memoizedIndividualDataEth = useMemo(()=> dataEth ,[dataEth])

      //all data from API
      const apiDataEth  = dataEth

      //all data which aint filtered
      const datazzEth =  [apiDataEth?.data]

  //fetch  Cardano
  let timerss;
  useEffect(()=>{
  setLoading(true)
  setDataAda(JSON.parse(localStorage.getItem("cardano")))
  timers = setInterval(()=>{
        const URL = "https://api.coincap.io/v2/assets/cardano"
        const fetchData =async (URL)=>{
          try{
            const res = await axios.get(URL)
            localStorage.setItem("cardano" , JSON.stringify(res.data))
            setDataAda(res.data)
            setLoading(false)
            setError(false)
            
          }catch(err){
            setDataAda(JSON.parse(localStorage.getItem("cardano")))
            setLoading(false)
            setError(true)
          }
        }
        fetchData(URL)
        },200)
        return ()=>{clearInterval(timerss)}
        
      },[URL])

      //cache
      // const memoizedIndividualDataAda = useMemo(()=> dataAda ,[dataAda])

      //all data from API
      const apiDataAda  = dataAda

      //all data which aint filtered
      const datazzAda =  [apiDataAda?.data]

  // //fetch  Matic
  // let timersss;
  // useEffect(()=>{
  // setLoading(true)
  // timers = setInterval(()=>{
  //       const URL = "https://api.coincap.io/v2/assets/polygon"
  //       const fetchData =async (URL)=>{
  //         try{
  //           const res = await axios.get(URL)
  //           localStorage.setItem("matic" , JSON.stringify(res.data))
  //           setDataMatic(res.data)
  //           setLoading(false)
  //           setError(false)
            
  //         }catch(err){
  //           setDataMatic(JSON.parse(localStorage.getItem("matic")))
  //           setLoading(false)
  //           setError(true)
  //         }
  //       }
  //       fetchData(URL)
  //       },200)
  //       return ()=>{clearInterval(timersss)}
        
  //     },[URL])

  //     //cache
  //     const memoizedIndividualDataMatic = useMemo(()=> dataMatic ,[dataMatic])

  //     //all data from API
  //     const apiDataMatic  = memoizedIndividualDataMatic

  //     //all data which aint filtered
  //     const datazzMatic =  [apiDataMatic.data]

  //fetch  Polkadot
  let timerssss;
  useEffect(()=>{
  setLoading(true)
  setDataDot(JSON.parse(localStorage.getItem("polkadot")))
  timers = setInterval(()=>{
        const URL = "https://api.coincap.io/v2/assets/polkadot"
        const fetchData =async (URL)=>{
          try{
            const res = await axios.get(URL)
            localStorage.setItem("polkadot" , JSON.stringify(res.data))
            setDataDot(res.data)
            setLoading(false)
            setError(false)
            
          }catch(err){
            setDataDot(JSON.parse(localStorage.getItem("polkadot")))
            setLoading(false)
            setError(true)
          }
        }
        fetchData(URL)
        },200)
        return ()=>{clearInterval(timerssss)}
        
      },[URL])

      //cache
      // const memoizedIndividualDataDot = useMemo(()=> dataDot ,[dataDot])

      //all data from API
      const apiDataDot  = dataDot

      //all data which aint filtered
      const datazzDot =  [apiDataDot?.data]

  //fetch  Doge
  let timersssss;
  useEffect(()=>{
  setLoading(true)
  setDataDoge(JSON.parse(localStorage.getItem("dogecoin")))
  timers = setInterval(()=>{
        const URL = "https://api.coincap.io/v2/assets/dogecoin"
        const fetchData =async (URL)=>{
          try{
            const res = await axios.get(URL)
            localStorage.setItem("dogecoin" , JSON.stringify(res.data))
            setDataDoge(res.data)
            setLoading(false)
            setError(false)
            
          }catch(err){
            setDataDoge(JSON.parse(localStorage.getItem("dogecoin")))
            setLoading(false)
            setError(true)
          }
        }
        fetchData(URL)
        },200)
        return ()=>{clearInterval(timersssss)}
        
      },[URL])

      //cache
      // const memoizedIndividualDataDoge = useMemo(()=> dataDoge ,[dataDoge])

      //all data from API
      const apiDataDoge  = dataDoge

      //all data which aint filtered
      const datazzDoge =  [apiDataDoge?.data]

    return (
    <TableContainer className='hotCoins'>
      <Table className='hotCoins_table'>
        <TableHead className='hot_table_head'>
          <TableRow className='hot_table_row'>
            <TableCell className='hot_table_cell_asset' sx={{fontWeight: "bold"}}>Name</TableCell>
            <TableCell align='right'  className='hot_table_cell_Price' sx={{fontWeight: "bold"}}>LastPrice</TableCell>
            <TableCell  align='right' className='hot_table_cell_percentage' sx={{fontWeight: "bold"}}>24hchg%</TableCell>
              <TableCell  align='right' className='hot_table_cell_track'  sx={{fontWeight: "bold"}}>All tracks</TableCell>
          </TableRow>
        </TableHead>

        {/* //BITCOIN TABLE */}
        {loading ?
        <div className='marketz_loading'>
            <LoadingAnimation/>
         </div>
          : <TableBody>
          {datazzBtc?.map((item)=>
            <TableRow  className="hot_body_row" 
              onClick={
              ()=>{
                //change name on localStorage
                dispatch({type: "ACTIONS", payload: item?.id})
                setTimeout(()=>{
                  navigate("/starttracking")
                },200)
              }
              }
            >
              <TableCell className='hot_table_body'  sx={{borderBottom: "0px"}}>              
                <div className='hot_to_add_favorite'>
                <StarOutline className='star' />
                  <div className='hot_coin_name'>
                    <div className="hot_coin_name_and_symbol">
                      <p className='hot_coin_names'>{item?.symbol}</p>
                     <p className='hot_coin_symbols'>{item?.name}</p>
                    </div>
                  </div>
                </div>
              </TableCell>
                <TableCell  align='right' className='hot_table_cell_current_price' >
                   ${Number(item?.priceUsd) < 1  ? Number(item?.priceUsd).toFixed(5) : Number(item?.priceUsd).toFixed(2)}
                </TableCell>
                <TableCell  align='right' className='table_cell_percentage'>
                  <button className={Number(item?.changePercent24Hr) < 0 ? "hot_table_cell_percentage_button_red" : "hot_table_cell_percentage_button"}>
                    {Number(item?.changePercent24Hr).toFixed(2)}%
                  </button>
                </TableCell>
                <TableCell  align='right' className='table_cell_track'>
                  <div className='hot_button'>
                    <button>Trade</button>
                  </div>
                </TableCell>
            </TableRow>
        )}
        </TableBody>}

        {/* //ETHERIUM TABLE */}
        {loading ?
        <div className='marketz_loading'>
            <LoadingAnimation/>
         </div>
          : <TableBody>
          {datazzEth?.map((item)=>
            <TableRow  className="hot_body_row" 
            onClick={
              ()=>{
                //change name on localStorage
                dispatch({type: "ACTIONS", payload: item?.id})
                setTimeout(()=>{
                  navigate("/starttracking")
                },200)
              }
              }
            >
              <TableCell className='hot_table_body'  sx={{borderBottom: "0px"}}>              
                <div className='hot_to_add_favorite'>
                <StarOutline className='star' />
                  <div className='hot_coin_name'>
                    <div className="hot_coin_name_and_symbol">
                      <p className='hot_coin_names'>{item?.symbol}</p>
                     <p className='hot_coin_symbols'>{item?.name}</p>
                    </div>
                  </div>
                </div>
              </TableCell>
                <TableCell  align='right' className='hot_table_cell_current_price' >
                   ${Number(item?.priceUsd) < 1  ? Number(item?.priceUsd).toFixed(5) : Number(item?.priceUsd).toFixed(2)}
                </TableCell>
                <TableCell  align='right' className='table_cell_percentage'>
                  <button className={Number(item?.changePercent24Hr) < 0 ? "hot_table_cell_percentage_button_red" : "hot_table_cell_percentage_button"}>
                    {Number(item?.changePercent24Hr).toFixed(2)}%
                  </button>
                </TableCell>
                <TableCell  align='right' className='table_cell_track'>
                  <div className='hot_button'>
                    <button>Trade</button>
                  </div>
                </TableCell>
            </TableRow>
        )}
        </TableBody>}

         {/* //Cardano TABLE */}
         {loading ?
        <div className='marketz_loading'>
            <LoadingAnimation/>
         </div>
          : <TableBody>
          {datazzAda?.map((item)=>
            <TableRow  className="hot_body_row" 
            onClick={
              ()=>{
                //change name on localStorage
                dispatch({type: "ACTIONS", payload: item?.id})
                setTimeout(()=>{
                  navigate("/starttracking")
                },200)
              }
              }
            >
              <TableCell className='hot_table_body'  sx={{borderBottom: "0px"}}>              
                <div className='hot_to_add_favorite'>
                <StarOutline className='star' />
                  <div className='hot_coin_name'>
                    <div className="hot_coin_name_and_symbol">
                      <p className='hot_coin_names'>{item?.symbol}</p>
                     <p className='hot_coin_symbols'>{item?.name}</p>
                    </div>
                  </div>
                </div>
              </TableCell>
                <TableCell  align='right' className='hot_table_cell_current_price' >
                   ${Number(item?.priceUsd) < 1  ? Number(item?.priceUsd).toFixed(5) : Number(item?.priceUsd).toFixed(2)}
                </TableCell>
                <TableCell  align='right' className='table_cell_percentage'>
                  <button className={Number(item?.changePercent24Hr) < 0 ? "hot_table_cell_percentage_button_red" : "hot_table_cell_percentage_button"}>
                    {Number(item?.changePercent24Hr).toFixed(2)}%
                  </button>
                </TableCell>
                <TableCell  align='right' className='table_cell_track'>
                  <div className='hot_button'>
                    <button>Trade</button>
                  </div>
                </TableCell>
            </TableRow>
        )}
        </TableBody>}

         {/* //Matic TABLE
         {loading ?
        <div className='marketz_loading'>
            <LoadingAnimation/>
         </div>
          : <TableBody>
          {datazzMatic?.map((item)=>
            <TableRow  className="hot_body_row" 
              // onClick={()=>{
              //   navigate("/login")
              // }}
            >
              <TableCell className='hot_table_body'  sx={{borderBottom: "0px"}}>              
                <div className='hot_to_add_favorite'>
                <StarOutline className='star' />
                  <div className='hot_coin_name'>
                    <div className="hot_coin_name_and_symbol">
                      <p className='hot_coin_names'>{item?.symbol}</p>
                     <p className='hot_coin_symbols'>{item?.name}</p>
                    </div>
                  </div>
                </div>
              </TableCell>
                <TableCell  align='right' className='hot_table_cell_current_price' >
                   ${Number(item?.priceUsd) < 1  ? Number(item?.priceUsd).toFixed(5) : Number(item?.priceUsd).toFixed(2)}
                </TableCell>
                <TableCell  align='right' className='table_cell_percentage'>
                  <button className={Number(item?.changePercent24Hr) < 0 ? "hot_table_cell_percentage_button_red" : "hot_table_cell_percentage_button"}>
                    {Number(item?.changePercent24Hr).toFixed(2)}%
                  </button>
                </TableCell>
                <TableCell  align='right' className='table_cell_track'>
                  <div className='hot_button'>
                    <button>Trade</button>
                  </div>
                </TableCell>
            </TableRow>
        )}
        </TableBody>} */}


         {/* //Polkadot TABLE */}
         {loading ?
        <div className='marketz_loading'>
            <LoadingAnimation/>
         </div>
          : <TableBody>
          {datazzDot?.map((item)=>
            <TableRow  className="hot_body_row" 
            onClick={
              ()=>{
                //change name on localStorage
                dispatch({type: "ACTIONS", payload: item?.id})
                setTimeout(()=>{
                  navigate("/starttracking")
                },200)
              }
              }
            >
              <TableCell className='hot_table_body'  sx={{borderBottom: "0px"}}>              
                <div className='hot_to_add_favorite'>
                <StarOutline className='star' />
                  <div className='hot_coin_name'>
                    <div className="hot_coin_name_and_symbol">
                      <p className='hot_coin_names'>{item?.symbol}</p>
                     <p className='hot_coin_symbols'>{item?.name}</p>
                    </div>
                  </div>
                </div>
              </TableCell>
                <TableCell  align='right' className='hot_table_cell_current_price' >
                   ${Number(item?.priceUsd) < 1  ? Number(item?.priceUsd).toFixed(5) : Number(item?.priceUsd).toFixed(2)}
                </TableCell>
                <TableCell  align='right' className='table_cell_percentage'>
                  <button className={Number(item?.changePercent24Hr) < 0 ? "hot_table_cell_percentage_button_red" : "hot_table_cell_percentage_button"}>
                    {Number(item?.changePercent24Hr).toFixed(2)}%
                  </button>
                </TableCell>
                <TableCell  align='right' className='table_cell_track'>
                  <div className='hot_button'>
                    <button>Trade</button>
                  </div>
                </TableCell>
            </TableRow>
        )}
        </TableBody>}


         {/* //Dogecoin TABLE */}
         {loading ?
        <div className='marketz_loading'>
            <LoadingAnimation/>
         </div>
          : <TableBody>
          {datazzDoge?.map((item)=>
            <TableRow  className="hot_body_row" 
            onClick={
              ()=>{
                //change name on localStorage
                dispatch({type: "ACTIONS", payload: item?.id})
                setTimeout(()=>{
                  navigate("/starttracking")
                },200)
              }
              }
            >
              <TableCell className='hot_table_body'  sx={{borderBottom: "0px"}}>              
                <div className='hot_to_add_favorite'>
                <StarOutline className='star' />
                  <div className='hot_coin_name'>
                    <div className="hot_coin_name_and_symbol">
                      <p className='hot_coin_names'>{item?.symbol}</p>
                     <p className='hot_coin_symbols'>{item?.name}</p>
                    </div>
                  </div>
                </div>
              </TableCell>
                <TableCell  align='right' className='hot_table_cell_current_price' >
                   ${Number(item?.priceUsd) < 1  ? Number(item?.priceUsd).toFixed(5) : Number(item?.priceUsd).toFixed(2)}
                </TableCell>
                <TableCell  align='right' className='table_cell_percentage'>
                  <button className={Number(item?.changePercent24Hr) < 0 ? "hot_table_cell_percentage_button_red" : "hot_table_cell_percentage_button"}>
                    {Number(item?.changePercent24Hr).toFixed(2)}%
                  </button>
                </TableCell>
                <TableCell  align='right' className='table_cell_track'>
                  <div className='hot_button'>
                    <button>Trade</button>
                  </div>
                </TableCell>
            </TableRow>
        )}
        </TableBody>}


         {/* //XRP TABLE
         {loading ?
        <div className='marketz_loading'>
            <LoadingAnimation/>
         </div>
          : <TableBody>
          {datazzXrp?.map((item)=>
            <TableRow  className="hot_body_row" 
              // onClick={()=>{
              //   navigate("/login")
              // }}
            >
              <TableCell className='hot_table_body'  sx={{borderBottom: "0px"}}>              
                <div className='hot_to_add_favorite'>
                <StarOutline className='star' />
                  <div className='hot_coin_name'>
                    <div className="hot_coin_name_and_symbol">
                      <p className='hot_coin_names'>{item?.symbol}</p>
                     <p className='hot_coin_symbols'>{item?.name}</p>
                    </div>
                  </div>
                </div>
              </TableCell>
                <TableCell  align='right' className='hot_table_cell_current_price' >
                   ${Number(item?.priceUsd) < 1  ? Number(item?.priceUsd).toFixed(5) : Number(item?.priceUsd).toFixed(2)}
                </TableCell>
                <TableCell  align='right' className='table_cell_percentage'>
                  <button className={Number(item?.changePercent24Hr) < 0 ? "hot_table_cell_percentage_button_red" : "hot_table_cell_percentage_button"}>
                    {Number(item?.changePercent24Hr).toFixed(2)}%
                  </button>
                </TableCell>
                <TableCell  align='right' className='table_cell_track'>
                  <div className='hot_button'>
                    <button>Trade</button>
                  </div>
                </TableCell>
            </TableRow>
        )}
        </TableBody>} */}
      </Table>
    </TableContainer>
  )
}

export default Hot

